import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const resendReturnInvoice = {
  name: "resendReturnInvoice" as const,
  input: z.object({
    returnId: zExt.objectId(),
    emailOverride: z.string().optional(),
  }),
  output: z.null(),
};
